import { Center, Title } from '@mantine/core'

import { GlobalError } from '@/shared/lib/global-error'
import { useTranslation } from '@/shared/lib/i18n'
import { PAGE_URL } from '@/shared/routes'
import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { Link } from '@/shared/ui/link'
import { Paragraph } from '@/shared/ui/typography'

interface Props {
  errorCode: GlobalError
  onRetryClick?: () => void
  extra?: React.ReactNode
}

export const ErrorScreen: React.FC<Props> = ({ errorCode, extra, onRetryClick }) => {
  const { t } = useTranslation()

  const content =
    errorCode === GlobalError.NotFound ? (
      <div className="flex w-full max-w-[var(--sn-auth-paper-max-width)] flex-col items-center rounded-lg bg-white px-5 py-[20px]">
        <Icon name="Feather.Meh" className="h-[50px] w-[50px] text-danger" />
        <Title order={2} className="whitespace-break-spaces pt-[12px] text-center">
          {t('page404.title404')}
        </Title>
        <Paragraph size="m" className="py-[24px] text-center">
          {t('page404.subtitle404')}
          <Link className="text-brand" href={PAGE_URL.main}>
            {t('page404.button404')}
          </Link>
        </Paragraph>
        {extra}
      </div>
    ) : (
      <div className="flex w-full max-w-[var(--sn-auth-paper-max-width)] flex-col items-center rounded-lg bg-white px-5 py-[20px]">
        <Icon name="Feather.Meh" className="h-[50px] w-[50px] text-danger" />
        <Title order={2} className="whitespace-break-spaces pt-[12px] text-center">
          {t('page500.title500')}
        </Title>
        {onRetryClick && (
          <Button variant="primary" className="mt-3 w-full" onClick={onRetryClick}>
            {t('page500.button500')}
          </Button>
        )}
        {extra}
      </div>
    )

  return <Center className="bg-surface-background px-[20px] py-[16px] max-desktop:items-start">{content}</Center>
}
